import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";

interface VehicleListingsProps {
  type: string;
  searchTerm?: string;
  featured?: boolean;
}

const VehicleListings = ({ type, searchTerm = "", featured = false }: VehicleListingsProps) => {

  const navigate = useNavigate();

  const [rows] = useState([
    // Car
    {
      id: 1,
      type: "Car",
      vehicleName: "Mercedes-Benz C-Class",
      model: "C 63 AMG",
      miles: "100K Miles",
      condition: "used",
      dealerName: "John Motors",
      dealerPhone: "9876543210",
      discountedPrice: "$42,900",
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 2,
      type: "Car",
      vehicleName: "Mercedes-Benz C-Class",
      model: "C 63 AMG",
      miles: "100K Miles",
      condition: "new",
      dealerName: "Auto Hub",
      dealerPhone: "9876501234",
      discountedPrice: "$42,900",
      createdDate: "05-Sept-2025",
      status: false,
    },

    // Bike
    {
      id: 3,
      type: "Bike",
      vehicleName: "Ducati Streetfighter",
      model: "Streetfighter V6",
      miles: "24K Miles",
      condition: "used",
      dealerName: "Speed Motors",
      dealerPhone: "9123456780",
      discountedPrice: "€900",
      createdDate: "02-Sept-2025",
      status: true,
    },
    {
      id: 4,
      type: "Bike",
      vehicleName: "Ducati Streetfighter",
      model: "Streetfighter V6",
      miles: "24K Miles",
      condition: "new",
      dealerName: "Moto World",
      dealerPhone: "9988776655",
      discountedPrice: "€1,650",
      createdDate: "06-Sept-2025",
      status: false,
    },

    // Bicycle
    {
      id: 5,
      type: "Bicycle",
      vehicleName: "Riese & Müller Nevo4 GT Automatic",
      model: "Hub gears",
      miles: "300 Wh",
      condition: "new",
      dealerName: "Cycle Hub",
      dealerPhone: "9012345678",
      discountedPrice: "€200",
      createdDate: "03-Sept-2025",
      status: true,
    },
    {
      id: 6,
      type: "Bicycle",
      vehicleName: "Riese & Müller Nevo4 GT Automatic",
      model: "Hub gears",
      miles: "300 Wh",
      condition: "new",
      dealerName: "Ride Store",
      dealerPhone: "9876123450",
      discountedPrice: "€320",
      createdDate: "07-Sept-2025",
      status: true,
    },

    // Caravan
    {
      id: 7,
      type: "Caravan",
      vehicleName: "Carado T 334 / T65",
      model: "C-Class Cabriolet",
      miles: "24K Miles",
      condition: "used",
      dealerName: "Travel Motors",
      dealerPhone: "9001122334",
      discountedPrice: "€22,000",
      createdDate: "04-Sept-2025",
      status: true,
    },
    {
      id: 8,
      type: "Caravan",
      vehicleName: "Carado T 334 / T65",
      model: "C-Class Cabriolet",
      miles: "24K Miles",
      condition: "new",
      dealerName: "Camper Store",
      dealerPhone: "9002233445",
      discountedPrice: "€26,000",
      createdDate: "08-Sept-2025",
      status: false,
    },

    // Trucks
    {
      id: 9,
      type: "Trucks",
      vehicleName: "Tata Truck on scenic H410...",
      model: "Benz C 63",
      miles: "100K Miles",
      condition: "used",
      dealerName: "Heavy Wheels",
      dealerPhone: "9112233445",
      discountedPrice: "€95,000",
      createdDate: "09-Sept-2025",
      status: true,
    },
    {
      id: 10,
      type: "Trucks",
      vehicleName: "Tata Truck on scenic H410...",
      model: "Benz C 63",
      miles: "100K Miles",
      condition: "new",
      dealerName: "Truck Care",
      dealerPhone: "9223344556",
      discountedPrice: "€86,000",
      createdDate: "10-Sept-2025",
      status: true,
    },

    // Heavy Equipment
    {
      id: 11,
      type: "Heavy Equipment",
      vehicleName: "Caterpillar Excavator 320",
      model: "C-Class Cabriolet",
      miles: "24K Miles",
      condition: "used",
      dealerName: "BuildPro",
      dealerPhone: "9334455667",
      discountedPrice: "€135,000",
      createdDate: "11-Sept-2025",
      status: false,
    },
    {
      id: 12,
      type: "Heavy Equipment",
      vehicleName: "Caterpillar Excavator 320",
      model: "C-Class Cabriolet",
      miles: "24K Miles",
      condition: "new",
      dealerName: "Mega Machines",
      dealerPhone: "9445566778",
      discountedPrice: "€170,000",
      createdDate: "12-Sept-2025",
      status: true,
    },
  ]);

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{type} Detail</TableCell>
              <TableCell>Dealer Detail</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Listed Date</TableCell>
              <TableCell>Enable/Disable</TableCell>
              <TableCell>Featured</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows
              .filter((row) => row.type === type)
              .map((row, index) => (
                <TableRow hover key={row.id}>
                  <TableCell>
                    <div className="user_block">
                      <figure className="no_radius">
                        <img src="/static/images/placeholder.png" alt={row.vehicleName} />
                      </figure>
                      <div>
                        <p>
                          <b className="flex">
                            <span className="limit">{row.vehicleName}</span>
                            {row.condition && (
                              <span
                                className={`status_btn ${row.condition === "used" ? "c_dark_warning" : "c_dark_info"
                                  }`}
                              >
                                {row.condition === "used" ? "Used" : "New"}
                              </span>
                            )}
                          </b>
                          {(row.model || row.miles) && (
                            <span>{row.model} • {row.miles}</span>
                          )}
                        </p>
                      </div>
                    </div>
                  </TableCell>

                  <TableCell>
                    <a
                      href="/manage-dealers/detail"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/manage-dealers/detail");
                      }}
                      className="user_block click_action">
                      <p>
                        <b>{row.dealerName}</b>
                        <span>{row.dealerPhone}</span>
                      </p>
                    </a>
                  </TableCell>

                  <TableCell>
                    <strong className="c_primary">{row.discountedPrice}</strong>
                  </TableCell>

                  <TableCell>{row.createdDate}</TableCell>

                  <TableCell>
                    <SwitchToggle defaultChecked={row.status} />
                  </TableCell>

                  <TableCell>
                    <SwitchToggle defaultChecked={featured === true} />
                  </TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => navigate(`/manage-vehicles/detail?type=${row.type}`)}>
                        <img src="/static/images/eye_icon.svg" alt="View" />
                      </IconButton>

                      <IconButton onClick={() => navigate("/manage-vehicles/edit")}>
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>

                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default VehicleListings;
